import React from "react"
import { Link } from "react-router-dom"

function Nav () {
  return (
    <nav>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/videos">Videos</Link></li>
        <li><Link to="/downloads">Downloads</Link></li>
        <li><Link to="/social">Social</Link></li>
      </ul>
    </nav>
  )
}

export default Nav